import {
    GridActionsCellItem,
} from '@mui/x-data-grid';

function EditStatusActionItem({handleSubmit, ...props }) {

    return (
        <>
            <GridActionsCellItem {...props} onClick={handleSubmit} />
        </>
    );

}

export default EditStatusActionItem
